import { Document } from '@contentful/rich-text-types';
import cloneDeep from 'lodash/cloneDeep';
import { ContentImage } from './content-image.model';
import { Deserializable } from './deserializable.model';
import { JsonObject } from './json-object.model';
import { Serializable } from './serializable.model';

export class ContentMedia implements Deserializable<JsonObject, ContentMedia>, Serializable<JsonObject> {
  constructor(
    public url?: string,
    public fileName?: string,
    public contentType?: string,
    public title?: string,
    public description?: string,
    public size?: number,
    public rawTranscript?: Document,
    public placeholderImage?: ContentImage,
    public height?: number,
    public width?: number
  ) {}

  deserialize(json: JsonObject) {
    if (
      json == null ||
      (json['media'] == null && json['file'] == null) ||
      (json['media'] != null && (json['media'] as JsonObject)['file'] == null)
    ) {
      return null;
    }
    const media = (json['media'] || json) as JsonObject;
    const file = (json['file'] || media['file']) as JsonObject;
    const details = (file['details'] || {}) as JsonObject;
    const image = (details['image'] || {}) as JsonObject;

    this.url = file['url'] as string;
    this.fileName = file['fileName'] as string;
    this.contentType = file['contentType'] as string;
    this.title = (media['title'] as string) || '';
    this.description = (media['description'] as string) || '';
    this.size = (details['size'] as number) || 0;
    this.height = (image['height'] as number) || 0;
    this.width = (image['width'] as number) || 0;
    this.rawTranscript = json['transcript'] as Document;
    this.placeholderImage = new ContentImage().deserialize(json['placeholderImage'] || json['placeholder_image']);

    return this;
  }

  clone(contentMedia: ContentMedia) {
    return cloneDeep(contentMedia);
  }

  serialize() {
    if (this == null) {
      return {};
    }
    return {
      file: {
        url: this.url,
        details: {
          size: this.size,
          image: {
            height: this.height,
            width: this.width,
          },
        },
        fileName: this.fileName,
        contentType: this.contentType,
      },
      title: this.title,
      description: this.description,
      placeholderImage: this.placeholderImage?.serialize?.(),
    };
  }

  get asImage(): ContentImage {
    return this.isAudio || this.isVideo ? this.placeholderImage : new ContentImage().deserialize(this.serialize());
  }

  get isImage(): boolean {
    return this.contentType?.includes('image/');
  }

  get isVideo(): boolean {
    return this.contentType?.includes('video/');
  }

  get isAudio(): boolean {
    return this.contentType?.includes('audio/');
  }
}
